import { render, staticRenderFns } from "./VitalsignModal.vue?vue&type=template&id=a315fcc4&scoped=true&"
import script from "./VitalsignModal.vue?vue&type=script&lang=ts&"
export * from "./VitalsignModal.vue?vue&type=script&lang=ts&"
import style0 from "./VitalsignModal.vue?vue&type=style&index=0&id=a315fcc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a315fcc4",
  null
  
)

export default component.exports